module.exports = __webpack_public_path__ + "static/media/job_employees.71390844.svg";